import React from 'react';
import { useMediaQuery } from 'react-responsive';
import TabLayout from '../../../../components/shared/tab-layout';
import PageFooter from '../../../../components/shared/page-footer';
import LogoutButton from '../logout-button';
import ProfileHeader from '../profile-header';
import { ProfileTabKey } from '../../tabs';
import styles from '../../profile.module.scss';

interface ProfileTabPageProps {
    activeTab: ProfileTabKey;
    loading: boolean;
    children: React.ReactNode;
}

const ProfileTabPage: React.FC<ProfileTabPageProps> = ({ activeTab, loading, children }) => {
    const isMobile = useMediaQuery({ maxWidth: 1000 });

    const footer = isMobile ? (
        <PageFooter>
            <LogoutButton />
        </PageFooter>
    ) : null;

    const actions = !isMobile ? <LogoutButton /> : null;

    return (
        <div className={styles.profilePage}>
            <TabLayout
                header={<ProfileHeader activeTab={activeTab} actions={actions} loading={loading} />}
                bodyClassName={styles.profilePageBody}
                footer={footer}>
                {!loading && (
                    <div className={styles.profileContentScroll}>
                        {children}
                    </div>
                )}
            </TabLayout>
        </div>
    );
};

export default ProfileTabPage;
